var _g, _rect, _g2, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgReferrals = function SvgReferrals(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3715_8478)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3715_8478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.133,
    y: 0.133,
    width: 59.733,
    height: 59.733,
    rx: 29.867,
    fill: "url(#paint0_linear_3715_8478)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3715_8478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.133,
    y: 0.133,
    width: 59.733,
    height: 59.733,
    rx: 29.867,
    fill: "url(#paint1_linear_3715_8478)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3715_8478)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_3715_8478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1 16c1.575 0 3.038.875 3.882 2.187.787 1.367.787 3.063 0 4.375A4.559 4.559 0 0 1 20.1 24.75a4.583 4.583 0 0 1-3.938-2.188c-.787-1.313-.787-3.008 0-4.375.844-1.313 2.306-2.188 3.938-2.188Zm20.7 0c1.576 0 3.038.875 3.882 2.187.787 1.367.787 3.063 0 4.375A4.559 4.559 0 0 1 40.8 24.75a4.583 4.583 0 0 1-3.937-2.188c-.788-1.313-.788-3.008 0-4.375.844-1.313 2.306-2.188 3.938-2.188ZM12 32.35c0-3.226 2.644-5.851 5.963-5.851h2.419c.9 0 1.743.218 2.531.546-.113.383-.113.82-.113 1.204 0 2.132.9 3.992 2.42 5.25H13.181c-.675 0-1.181-.493-1.181-1.149ZM34.782 33.5h-.056c1.518-1.257 2.418-3.117 2.418-5.25 0-.382 0-.82-.056-1.203a6.065 6.065 0 0 1 2.475-.546h2.419C45.3 26.5 48 29.125 48 32.35c0 .656-.563 1.148-1.238 1.148H34.782ZM24.6 28.25c0-1.859 1.012-3.554 2.7-4.538 1.63-.93 3.712-.93 5.4 0 1.63.984 2.7 2.68 2.7 4.539 0 1.914-1.07 3.609-2.7 4.593-1.688.93-3.77.93-5.4 0-1.688-.984-2.7-2.68-2.7-4.594Zm-5.4 14.329c0-4.047 3.318-7.329 7.48-7.329h6.582c4.163 0 7.538 3.282 7.538 7.329 0 .765-.675 1.421-1.52 1.421H20.664c-.788 0-1.462-.601-1.462-1.421Z",
    fill: "url(#paint2_linear_3715_8478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 16c1.575 0 3.038.875 3.882 2.187.787 1.367.787 3.063 0 4.375A4.559 4.559 0 0 1 20.1 24.75a4.583 4.583 0 0 1-3.938-2.188c-.787-1.313-.787-3.008 0-4.375.844-1.313 2.306-2.188 3.938-2.188Zm20.7 0c1.576 0 3.038.875 3.882 2.187.787 1.367.787 3.063 0 4.375A4.559 4.559 0 0 1 40.8 24.75a4.583 4.583 0 0 1-3.937-2.188c-.788-1.313-.788-3.008 0-4.375.844-1.313 2.306-2.188 3.938-2.188ZM12 32.35c0-3.226 2.644-5.851 5.963-5.851h2.419c.9 0 1.743.218 2.531.546-.113.383-.113.82-.113 1.204 0 2.132.9 3.992 2.42 5.25H13.181c-.675 0-1.181-.493-1.181-1.149ZM34.782 33.5h-.056c1.518-1.257 2.418-3.117 2.418-5.25 0-.382 0-.82-.056-1.203a6.065 6.065 0 0 1 2.475-.546h2.419C45.3 26.5 48 29.125 48 32.35c0 .656-.563 1.148-1.238 1.148H34.782ZM24.6 28.25c0-1.859 1.012-3.554 2.7-4.538 1.63-.93 3.712-.93 5.4 0 1.63.984 2.7 2.68 2.7 4.539 0 1.914-1.07 3.609-2.7 4.593-1.688.93-3.77.93-5.4 0-1.688-.984-2.7-2.68-2.7-4.594Zm-5.4 14.329c0-4.047 3.318-7.329 7.48-7.329h6.582c4.163 0 7.538 3.282 7.538 7.329 0 .765-.675 1.421-1.52 1.421H20.664c-.788 0-1.462-.601-1.462-1.421Z",
    stroke: "#000",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3715_8478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.278,
    cy: 39.704,
    rx: 11.983,
    ry: 11.161,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3715_8478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.714,
    cy: 9.249,
    rx: 14.999,
    ry: 6.678,
    fill: "url(#paint3_linear_3715_8478)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.633,
    y: 0.633,
    width: 58.733,
    height: 58.733,
    rx: 29.367,
    stroke: "url(#paint4_linear_3715_8478)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3715_8478",
    x1: 30,
    y1: 0.133,
    x2: 30,
    y2: 59.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3715_8478",
    x1: 30,
    y1: 0.133,
    x2: 30,
    y2: 59.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3715_8478",
    x1: 30,
    y1: 15.999,
    x2: 30,
    y2: 43.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3715_8478",
    x1: 22.661,
    y1: 0.378,
    x2: 5.342,
    y2: 2.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3715_8478",
    x1: 30,
    y1: 0.133,
    x2: 30,
    y2: 59.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969292",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3715_8478",
    x: -5.867,
    y: -5.867,
    width: 71.733,
    height: 71.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3715_8478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_3715_8478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_3715_8478",
    x: 10.3,
    y: 14.8,
    width: 39.4,
    height: 31.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3715_8478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3715_8478",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_3715_8478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3715_8478",
    x: 4.295,
    y: 2.543,
    width: 75.966,
    height: 74.322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3715_8478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3715_8478",
    x: -19.441,
    y: -13.585,
    width: 62.31,
    height: 45.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_3715_8478"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3715_8478"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgReferrals;